(function () {
  const STORAGE_KEY = "boboth_currency";
  const ALLOWED = ["USD", "EUR", "GBP"];
  const CURRENCY_COUNTRY = { GBP: "GB", EUR: "DE", USD: "US" };
  const cfg = window.BobothCurrency || {};
  const shopCurrency = (cfg.shopCurrency || "USD").toUpperCase();
  const country = (cfg.country || "US").toUpperCase();
  const defaultCurrency =
    (cfg.countryMap || { GB: "GBP", US: "USD" })[country] ||
    cfg.defaultCurrency ||
    "USD";
  const presentment = (cfg.presentmentCurrencies || [shopCurrency]).map(function (c) {
    return String(c).toUpperCase();
  });
  const nativeCheckout = presentment.length > 1;

  function readManual() {
    try {
      const saved = (localStorage.getItem(STORAGE_KEY) || "").toUpperCase();
      if (ALLOWED.indexOf(saved) !== -1) return saved;
    } catch (e) {}
    return null;
  }

  function writeManual(code) {
    try {
      localStorage.setItem(STORAGE_KEY, code);
    } catch (e) {}
  }

  function currentCurrency() {
    return readManual() || defaultCurrency;
  }

  function formatMoney(amount, currency) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: currency,
        currencyDisplay: "symbol",
      }).format(amount);
    } catch (e) {
      return amount.toFixed(2) + " " + currency;
    }
  }

  function convertMajor(amountMajor, from, to) {
    if (from === to) return amountMajor;
    if (window.Currency && typeof Currency.convert === "function") {
      try {
        return Currency.convert(amountMajor, from, to);
      } catch (e) {}
    }
    const vsUsd = { USD: 1, GBP: 0.79, EUR: 0.92, CAD: 1.36 };
    const fromRate = vsUsd[from] || 1;
    const toRate = vsUsd[to] || 1;
    return (amountMajor / fromRate) * toRate;
  }

  function apply(targetCurrency) {
    const currency = targetCurrency || currentCurrency();
    document.querySelectorAll("[data-boboth-amount]").forEach(function (el) {
      const cents = Number(el.getAttribute("data-boboth-amount"));
      if (!Number.isFinite(cents)) return;
      const from = (el.getAttribute("data-boboth-currency") || shopCurrency).toUpperCase();
      const major = cents / 100;
      if (nativeCheckout && from === currency) {
        el.textContent = formatMoney(major, currency);
      } else {
        if (nativeCheckout) return;
        const converted = convertMajor(major, from, currency);
        el.textContent = formatMoney(converted, currency);
      }
      el.setAttribute("data-boboth-display-currency", currency);
    });
    document.documentElement.setAttribute("data-boboth-currency", currency);
    document.documentElement.setAttribute("data-boboth-country", country);
    document.documentElement.setAttribute("data-boboth-native-checkout", nativeCheckout ? "1" : "0");
    const select = document.getElementById("Boboth-Currency-Select");
    if (select && select.value !== currency) select.value = currency;
  }

  function whenFxReady(fn) {
    if (nativeCheckout || (window.Currency && typeof Currency.convert === "function")) {
      fn();
      return;
    }
    let tries = 0;
    const timer = setInterval(function () {
      if ((window.Currency && typeof Currency.convert === "function") || ++tries > 50) {
        clearInterval(timer);
        fn();
      }
    }, 100);
  }

  function applySoon() {
    whenFxReady(function () {
      apply(currentCurrency());
    });
  }

  function syncCheckoutCurrency(code) {
    if (nativeCheckout === false) return Promise.resolve(false);
    const countryCode = CURRENCY_COUNTRY[code] || "US";
    const body = new URLSearchParams();
    body.set("currency", code);
    return fetch("/cart/update.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/x-www-form-urlencoded", Accept: "application/json" },
      body: body.toString(),
    })
      .then(function () {
        const loc = new URLSearchParams();
        loc.set("country_code", countryCode);
        return fetch("/localization", {
          method: "POST",
          credentials: "same-origin",
          body: loc.toString(),
          redirect: "manual",
        });
      })
      .then(function () {
        return fetch("/cart.js", {
          credentials: "same-origin",
          headers: { Accept: "application/json" },
        });
      })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        return !!(cart && String(cart.currency || "").toUpperCase() === code);
      })
      .catch(function () {
        return false;
      });
  }

  function bindSelector() {
    const select = document.getElementById("Boboth-Currency-Select");
    if (!select || select.dataset.bobothBound === "1") return;
    select.dataset.bobothBound = "1";
    select.value = currentCurrency();
    select.addEventListener("change", function () {
      const next = (select.value || "USD").toUpperCase();
      if (ALLOWED.indexOf(next) === -1) return;
      writeManual(next);
      select.disabled = true;
      syncCheckoutCurrency(next).then(function (switched) {
        select.disabled = false;
        if (switched) {
          window.location.reload();
          return;
        }
        applySoon();
      });
    });
  }

  function observeCartRoots() {
    if (document.documentElement.dataset.bobothMoneyObserver === "1") return;
    document.documentElement.dataset.bobothMoneyObserver = "1";
    let scheduled = false;
    const observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        applySoon();
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function boot() {
    bindSelector();
    applySoon();
    observeCartRoots();
    if (nativeCheckout) {
      const wanted = currentCurrency();
      if (wanted !== shopCurrency && presentment.indexOf(wanted) !== -1) {
        syncCheckoutCurrency(wanted).then(function (switched) {
          if (switched) window.location.reload();
        });
      }
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
  document.addEventListener("shopify:section:load", function () {
    bindSelector();
    applySoon();
  });
  ["cart:updated", "cart:refresh", "theme:cart:change"].forEach(function (evt) {
    document.addEventListener(evt, applySoon);
  });
})();
